<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Deviation Check</h2>
  </div>

  <mat-tab-group>
    <mat-tab label="Filters">
      <div class="filters-form">
        <form [formGroup]="filtersForm">
          <div class="form-fields">
            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Variable</mat-label>
              <mat-select formControlName="variable">
                @for (opt of variableOptions; track opt.value) {
                  <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Country</mat-label>
              <mat-select formControlName="countryId">
                @for (country of countries; track country.id) {
                  <mat-option [value]="country.id">{{ country.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Year</mat-label>
              <mat-select formControlName="year">
                <mat-option value="">Active Year</mat-option>
                @for (year of measurements; track year) {
                  <mat-option [value]="year">{{ year }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="form-field">
              <mat-label>Capitalization</mat-label>
              <mat-select formControlName="capitalization">
                <mat-option value="">Any</mat-option>
                @for (opt of capitalizationOptions; track opt.value) {
                  <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <div class="actions">
            <button
              mat-raised-button
              color="primary"
              type="button"
              [disabled]="filtersForm.invalid"
              (click)="onSearch()">
              <mat-icon>search</mat-icon>
              Search
            </button>
            <button
              mat-raised-button
              color="primary"
              type="button"
              [disabled]="filtersForm.invalid"
              (click)="onExport()">
              <mat-icon>file_download</mat-icon>
              Export CSV
            </button>
          </div>

          <div class="legend">
            <span class="legend-title">Cell legend:</span>
            <span class="legend-item"><code>0.15</code> = +15% vs prior year</span>
            <span class="legend-item"><code>n.l.y</code> = no last year data</span>
            <span class="legend-item"><code>c.y.e.</code> = current year empty</span>
            <span class="legend-item">(empty) = unchanged / no data</span>
          </div>
        </form>
      </div>
    </mat-tab>
  </mat-tab-group>

  @if (hasSearched) {
    @if (rows.length > 0) {
      <div class="results-table-wrapper">
        <table mat-table [dataSource]="rows" matSort (matSortChange)="onSortChange($event)" class="results-table">
          @for (col of prefixColumns; track col.key) {
            <ng-container [matColumnDef]="col.key">
              @if (col.sortKey) {
                <th mat-header-cell *matHeaderCellDef mat-sort-header [mat-sort-header]="col.sortKey">{{ col.label }}</th>
              } @else {
                <th mat-header-cell *matHeaderCellDef>{{ col.label }}</th>
              }
              <td mat-cell *matCellDef="let row">
                @if (col.key === 'companyName') {
                  <span class="name-cell">
                    <a [routerLink]="['/companies/edit', row.companyId]" target="_blank" rel="noopener" class="company-link-btn" title="Edit company">
                      <mat-icon>open_in_new</mat-icon>
                    </a>
                    {{ row.companyName }}
                  </span>
                } @else if (isBoolean(col.key)) {
                  @if (prefixCellRaw(row, col.key) === true) {
                    <mat-icon class="flag-icon">check</mat-icon>
                  }
                } @else {
                  {{ prefixCellRaw(row, col.key) }}
                }
              </td>
            </ng-container>
          }

          @for (header of headers; track header; let i = $index) {
            <ng-container [matColumnDef]="'cell_' + i">
              <th mat-header-cell *matHeaderCellDef class="deviation-header">{{ header }}</th>
              <td mat-cell *matCellDef="let row" [ngClass]="cellClass(cellValue(row, 'cell_' + i))">
                {{ cellValue(row, 'cell_' + i) }}
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        [pageIndex]="currentPage - 1"
        (page)="onPageChange($event)">
      </mat-paginator>
    } @else {
      <div class="empty-results">No matching records found</div>
    }
  }
</div>
